/**
 * Joins class names, dropping anything absent.
 *
 * CSS Module lookups are typed `string | undefined` under
 * `noUncheckedIndexedAccess`, because a typo in a class name is not a compile
 * error. This keeps that safety without spreading `?? ''` through the JSX, and
 * lets a conditional class be written inline as `condition && styles.active`.
 */
export function cx(...values: Array<string | false | null | undefined>): string {
  return values
    .filter((value): value is string => typeof value === 'string' && value !== '')
    .join(' ');
}
